export default "__VITE_ASSET__4b070345__"